<!--面板组件-->

<template>
  <div>
    <div class="overlay"></div>
    <div class="lightbox">
      <div class="dia_head">
        <div class="close_btn" @click="doClose()">
          <img src="@/assets/pc/icon-close.svg" alt="" />
        </div>
      </div>
      <div class="dia_title">
        <slot name="dia-content-title"></slot>
      </div>
      <div class="dia_content">
        <div class="dia_contents">
          <slot name="dia-content-solt"></slot>
        </div>

        <div class="disagree_box" v-if="needDisagree">
          <el-checkbox v-model="checked"></el-checkbox>
          <span>
            <slot name="dia-content-cbc"></slot>
          </span>
          <div class="disagree_btn">
            <el-button class="btns" :disabled="isDisbale" type="primary"  @click="doAgree()">{{ btn_name }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "Requirements",
  components: {},
  data() {
    return {
      checked: false,
      showModal:false,
    };
  },
  props: ["needDisagree", "btn_name"],
  computed: {
    isDisbale() {
      return !this.checked
    }
  },
  methods: {
    doClose() {
      this.$emit("closeDialog");
    },
    doAgree(){
      this.$emit("doAgree");
    }
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.46);
  z-index: 1;
}
.lightbox {
  background: #ffffff;
  border-radius: 10px;
  width: 823px;
  max-height: 583px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  padding: 16.11px 14.5px 40px 32px;
  .dia_head {
    height: 15.78px;
    width: 100%;
    text-align: right;
    .close_btn {
      cursor: pointer;
    }
  }
  .dia_title {
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    height: 27px;
    margin-bottom: 14px;
    .text_align{
      text-align: center;
    }
  }
  .dia_content {
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 480px;
    width: 100%;
    .dia_contents {
      padding-right: 12px;
      >div{
        height: 100%;
      }
    }
  }
  ul {
    list-style-type: disc !important;
    position: relative;
    top: -17px;
    left: -22px;
  }
  li {
    margin-bottom: 8px;
    font-size: 16px;
  }
  .disagree_box {
    text-align: center;
    margin-top: 28px;
    padding-right: 12px;
  }
  .disagree_btn {
    text-align: center;
    .btns {
      margin-top: 28px;
      border-radius: 8px;
      height: 48px;
      width: 288px;
    }
  }
}
</style>
